import { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import axios from "axios";
import { Table, notification } from "antd";
import warning from "../../../common/NotificationModal/assets/Exclamation.svg";
import { Image } from "../../../common/NotificationModal/styles";
import api_address from "../../../../constants/config";
import { History, LocationState } from "history";
import DropDown from "../../../common/DropDown";
import { getCountryCodeList } from "../../../../constants/countryCode";
import { getCountryInitial } from "constants/countryCode";
import countryList from "constants/countryList";
import { IS_NUMBER, IS_VALID_EMAIL } from "../../../../util/common";
import NotificationModal from "../../../common/NotificationModal";
import {
  ContainerWithGrid,
  GridColumn,
  ContentContainer,
  ContentSubtitle,
  Input,
  SaveButton,
  CancelButton,
} from "../../styles";
import {
  InputBorderDefault,
  InputBorderInvalid,
} from "../../Therapist/constant";
import {
  EDIT_COACH_SUBMIT,
  DELETE_COACH_BIO_SUBMIT,
  JS_COOKIE,
} from "util/auth";
import { ADMIN_COOKIE_NAME } from "constants/admin";
import TherapistBioTextbox from "components/common/TherapistBioTextbox";
import TimeZoneDropdown from "components/common/TimeZoneDropdown";
import { RedAsterisk } from "../../Therapist/styles";
import { Title } from "components/Admin/User/Edit/styles";
import { UploadContainer } from "components/common/VideoModal/style";
import { SNOWFLAKE } from "../../../../util/common";
import CoachAssignmentView from "components/Admin/CoachAssignmentView";
import UploaderOnGuide from "util/uploaderOnGuide";
import ImageUploader from "../../../common/ImageUploader";
import { getBase64 } from "../../../../util/therapist";
import {
  COACH_PROFILE_PICTURE_FOLDER,
  COACH_PROFILE_PICTURE_FOLDER_ON_S3_ROUTE,
} from "constants/common";
import ResetPasswordModal from "../../../common/ResetPasswordModal";
import { ResetPasswordButton } from "./styles";

const MAX_FILE_SIZE = 5; // 5MB
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"];

interface EditCoachProps {
  history: History<LocationState>;
  match: {
    params: {
      id: string;
    };
  };
}

interface EditCoachStates {
  [key: string]: number | string | boolean | Array<Object> | Array<string>;
  uuid: string;
  firstName: string;
  lastName: string;
  country: string;
  countryCode: string;
  phone: string;
  email: string;
  message: string;
  timeZone: string;
  bio: Array<{
    id: number;
    unique_bio_id: string;
    bio: string;
    language: string;
  }>;
  tempDeletedBio: Array<string>;
  isLoading: boolean;
  showModal: boolean;
  notificationStatus: boolean;
  coachUUID: string;
  dataLoading: boolean;
  title: string;
  consultationUrl: string;
  cnConsultationUrl: string;
  avatarFilename: string;
  disabled: boolean;
  isUploaded: boolean;
  originFileObj: any;
  avatarPreview: string;
  encodedFilename: string;
  createdAt: string;
  isResetPasswordModalVisible: boolean;
}

type Props = EditCoachProps & WithTranslation;

class EditCoach extends Component<Props, EditCoachStates> {
  constructor(props: Props) {
    super(props);
    this.state = {
      uuid: "",
      firstName: "",
      lastName: "",
      country: "",
      countryCode: "",
      phone: "",
      email: "",
      message: "",
      bio: [],
      tempDeletedBio: [],
      isLoading: false,
      timeZone: "",
      showModal: false,
      notificationStatus: false,
      coachUUID: "",
      dataLoading: true,
      createdAt: "",
      title: "",
      consultationUrl: "",
      cnConsultationUrl: "",
      avatarFilename: "",
      disabled: false,
      isUploaded: false,
      originFileObj: "",
      avatarPreview: "",
      encodedFilename: "",
      isResetPasswordModalVisible: false,
    };
  }

  showResetPasswordModal = () => {
    this.setState({ isResetPasswordModalVisible: true });
  };

  closeResetPasswordModal = () => {
    this.setState({ isResetPasswordModalVisible: false });
  };

  componentDidMount() {
    this.fetchCoachData();
  }

  fetchCoachData = async () => {
    try {
      const { id } = this.props.match.params;
      const { data } = await axios.get(api_address + "api/admin/coach/" + id, {
        headers: {
          Authorization: `Bearer ${JS_COOKIE.get(ADMIN_COOKIE_NAME)}`,
        },
      });
      const coach = data.coach.coachData;
      const coachBio = data.coach.coachBio || [];

      // Derive country from countryCode
      let country = "";
      if (coach.countrycode) {
        const countryCodeInitial = getCountryInitial(coach.countrycode);
        for (let i = 0; i < countryList.length; i++) {
          if (countryList[i].key === countryCodeInitial?.toLowerCase()) {
            country = countryList[i].key;
            break;
          }
        }
      }
      // Ensure country is never empty/null for GraphQL mutation
      if (!country) {
        country = "";
      }
      this.setState({
        coachUUID: coach.uuid,
        firstName: coach.firstName,
        lastName: coach.lastName,
        email: coach.email,
        countryCode: coach.countrycode,
        country: country,
        phone: coach.phone,
        timeZone: coach.time_zone,
        bio: coachBio,
        createdAt: coach.createdat,
        dataLoading: false,
        title: coach.title || "",
        consultationUrl: coach.consultation_url || "",
        cnConsultationUrl: coach.cn_consultation_url || "",
        avatarFilename: coach.avatar_filename || "",
        disabled: coach.disabled || false,
        avatarPreview: coach.avatar_filename
          ? `https://example.com/${coach.avatar_filename}`
          : "",
      });
    } catch (error) {
      console.error(error);
      this.displayErrorMessage("Failed to fetch coach data");
      this.setState({ dataLoading: false });
    }
  };

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.currentTarget;
    const input = document.getElementById(id);
    if (input) {
      input.style.border = InputBorderDefault;
    }
    this.setState({ [id]: value });
  };

  handleCountryCodeChange = (value: string) => {
    if (value != null)
      this.setState({
        countryCode: value,
      });
    const countryCode = getCountryInitial(value);
    for (let i = 0; i < countryList.length; i++) {
      if (countryList[i].key === countryCode?.toLowerCase()) {
        this.setState({ country: countryList[i].key });
        return;
      }
    }
  };

  handleStatus = (message: string, status: boolean) => {
    this.setState({
      message: message,
      notificationStatus: status,
      showModal: true,
    });
    setTimeout(() => {
      this.setState({ showModal: false });
    }, 3000);
  };

  showNotification = (message: string, status: boolean) => {
    this.setState({
      message: message,
      notificationStatus: status,
      showModal: true,
    });
    setTimeout(() => {
      this.setState({ showModal: false });
    }, 3000);
  };

  openNotification = (description: string, isSuccess: boolean = false) => {
    notification.info({
      message: (
        <p style={{ color: "White" }}>{isSuccess ? "Success" : "Error"}</p>
      ),
      icon: <Image src={warning} style={{ marginBottom: "2px" }} alt="" />,
      description: description,
      placement: "top",
      style: {
        color: "white",
        backgroundColor: isSuccess ? "#52c41a" : "#e8384f",
        height: "90px",
        width: "100%",
      },
    });
  };

  changeInputColor = (id) => {
    const input = document.getElementById(id);
    if (input) {
      input.style.border = InputBorderInvalid;
    }
  };

  validation = () => {
    const { email, phone, countryCode, firstName, lastName, timeZone, title } =
      this.state;
    let count = 0;
    if (firstName === "") {
      count += 1;
      this.changeInputColor("firstName");
      this.openNotification("First name is missing");
    }
    if (lastName === "") {
      count += 1;
      this.changeInputColor("lastName");
      this.openNotification("Last name is missing");
    }
    if (countryCode === "") {
      count += 1;
      this.changeInputColor("countryCode");
      this.openNotification("Country code is missing");
    }
    if (phone === "") {
      count += 1;
      this.changeInputColor("phone");
      this.openNotification("Phone number is missing");
    }
    if (!IS_NUMBER(phone)) {
      count += 1;
      this.setState({ phone: "" });
      this.changeInputColor("phone");
      this.openNotification("Phone number is invalid");
    }
    if (email === "") {
      count += 1;
      this.changeInputColor("email");
      this.openNotification("Email is missing");
    }
    if (!IS_VALID_EMAIL(email)) {
      count += 1;
      this.setState({ email: "" });
      this.changeInputColor("email");
      this.openNotification("Email is invalid");
    }
    if (timeZone === "") {
      count += 1;
      this.changeInputColor("timeZone");
      this.openNotification("Time zone is missing");
    }
    if (title === "") {
      count += 1;
      this.changeInputColor("title");
      this.openNotification("Title is missing");
    }
    return count === 0;
  };

  onCancelClick = () => {
    this.props.history.push("/admin/coach");
  };

  handleTimeZoneChange = (value: string) => {
    if (value) {
      this.setState({ timeZone: value });
    }
  };

  handleBio = (bioList: any) => {
    if (bioList) this.setState({ bio: bioList });
  };

  filterBioData = (language: string) => {
    const { bio } = this.state;

    if (!bio || bio.length === 0) return [];

    return bio.filter((item) => {
      if (!item) return false;
      else if (!item.language) {
        if (language === "EN") return true;
        return false;
      }
      return item.language === language;
    });
  };

  handleDeleteBio = async (unique_bio_id: string) => {
    try {
      let tempDeletedBioArr = this.state.tempDeletedBio;
      tempDeletedBioArr.push(unique_bio_id);
      this.setState({ tempDeletedBio: tempDeletedBioArr });
    } catch (error: any) {
      this.openNotification(error.message, false);
    }
  };

  beforeUpload = (file: any) => {
    const isValidType = ACCEPTED_IMAGE_TYPES.includes(file.type);
    if (!isValidType) {
      this.openNotification("You can only upload JPG/PNG files!", false);
      return false;
    }
    const isLt5M = file.size / 1024 / 1024 < MAX_FILE_SIZE;
    if (!isLt5M) {
      this.openNotification("123Image must be smaller than 5MB!", false);
      return false;
    }
    return true;
  };

  handleUploadImageForPreview = async (info: any) => {
    if (info.file.status === "uploading") {
      this.setState({ isUploaded: false });
      return;
    }
    if (info.file.status === "done" || info.file.status === "error") {
      try {
        const base64 = await getBase64(info.file.originFileObj);
        this.setState({
          isUploaded: true,
          originFileObj: info.file.originFileObj,
          avatarPreview: base64,
        });
      } catch (error) {
        this.openNotification("Failed to process image", false);
      }
    }
  };
  handleUploadImageToS3 = (coachUUID: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const { originFileObj } = this.state;
      const extension = originFileObj.type === "image/png" ? ".png" : ".jpg";
      const encodedFileName = coachUUID + extension;
      UploaderOnGuide(
        originFileObj,
        COACH_PROFILE_PICTURE_FOLDER,
        encodedFileName
      ).send((err, data) => {
        if (err) {
          reject(err);
          return;
        }
        this.setState(
          {
            isUploaded: true,
            encodedFilename: encodedFileName,
          },
          () => resolve()
        );
      });
    });
  };

  onSaveClick = async () => {
    try {
      if (this.validation() === false) throw new Error("Err by validation");
      this.setState({ isLoading: true });
      const token = JS_COOKIE.get(ADMIN_COOKIE_NAME);
      const { id } = this.props.match.params;

      const {
        email,
        phone,
        countryCode,
        country,
        firstName,
        lastName,
        bio,
        timeZone,
        coachUUID,
        tempDeletedBio,
        title,
        consultationUrl,
        cnConsultationUrl,
        disabled,
        originFileObj,
        avatarFilename,
      } = this.state;

      if (originFileObj !== "") {
        await this.handleUploadImageToS3(coachUUID);
      } else if (this.state.encodedFilename) {
        this.setState({ isUploaded: true });
      }

      // Delete bios marked for deletion
      let deleteBioResult;
      if (tempDeletedBio.length > 0) {
        deleteBioResult = await DELETE_COACH_BIO_SUBMIT(
          coachUUID,
          tempDeletedBio
        );
      }

      var snowFlakeUUID: Array<String> = [];
      for (let i = 0; i < bio.length; i++) {
        if (!bio[i].id) snowFlakeUUID.push(SNOWFLAKE.gen());
      }

      let finalAvatarFilename = avatarFilename;

      const updateCoach = {
        userUuid: coachUUID,
        firstName,
        lastName,
        email,
        timeZone,
        countrycode: countryCode,
        country: country || "",
        phone,
        title,
        consultationUrl,
        cnConsultationUrl,
        avatarFilename: finalAvatarFilename,
        disabled,
      };

      const result = await EDIT_COACH_SUBMIT(
        updateCoach,
        bio,
        snowFlakeUUID,
        token
      );
      if (result.status === "ERROR") {
        this.openNotification("Update failed", false);
        return;
      }
      await this.fetchCoachData();
      this.openNotification("Update successful", true);
      this.setState({ isLoading: false });
      this.props.history.push("/admin/coach");
    } catch (error: any) {
      this.setState({ isLoading: false });
      if (error.message !== "Err by validation")
        this.displayErrorMessage(error.message);
    }
  };

  displayErrorMessage = (message: string) => {
    this.setState({
      message: message,
      showModal: true,
    });
    setTimeout(() => {
      this.setState({ showModal: false });
    }, 3000);
  };

  render = () => {
    const { t } = this.props;
    const {
      coachUUID,
      showModal,
      message,
      notificationStatus,
      firstName,
      lastName,
      countryCode,
      phone,
      email,
      timeZone,
      bio,
      isLoading,
      dataLoading,
      title,
      consultationUrl,
      cnConsultationUrl,
      avatarPreview,
      avatarFilename,
      isUploaded,
      disabled,
      createdAt,
      isResetPasswordModalVisible,
    } = this.state;

    if (dataLoading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "40px",
          }}
        >
          Loading coach data...
        </div>
      );
    }

    const dataSourceEN = this.filterBioData("EN");
    const dataSourceZH_CN = this.filterBioData("ZH-CN");
    const dataSourceZH_TW = this.filterBioData("ZH-TW");
    const columnEN = [
      {
        title: "English",
        dataIndex: "bio",
        key: "bio",
        width: "1500px",
      },
    ];

    const columnZH_CN = [
      {
        title: "Simplified Chinese",
        dataIndex: "bio",
        key: "bio",
        width: "1500px",
      },
    ];

    const columnZH_TW = [
      {
        title: "Traditional Chinese",
        dataIndex: "bio",
        key: "bio",
        width: "1500px",
      },
    ];

    return (
      <div>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              fontSize: "40px",
            }}
          >
            Updating coach profile...
          </div>
        ) : (
          <div>
            <NotificationModal
              show={showModal}
              message={message}
              status={notificationStatus}
            />
            <ContainerWithGrid>
              <GridColumn>
                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.firstName")}
                    <RedAsterisk>*</RedAsterisk>
                  </ContentSubtitle>
                  <Input
                    onChange={this.handleInputChange}
                    id="firstName"
                    type="text"
                    value={firstName}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.lastName")}
                    <RedAsterisk>*</RedAsterisk>
                  </ContentSubtitle>
                  <Input
                    onChange={this.handleInputChange}
                    id="lastName"
                    type="text"
                    value={lastName}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.timeZone")}
                    <RedAsterisk>*</RedAsterisk>
                  </ContentSubtitle>
                  <TimeZoneDropdown
                    userId={"0"}
                    timeZone={timeZone}
                    userUuid={coachUUID}
                    showNotification={this.handleStatus}
                    handleTimeZoneChange={this.handleTimeZoneChange}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.countryCode")}
                    <RedAsterisk>*</RedAsterisk>
                  </ContentSubtitle>
                  <DropDown
                    componentName="admin - coach"
                    type="Country code"
                    size="medium-adminCreateTherapistPanel"
                    defaultSelection={countryCode}
                    selectedText={countryCode}
                    options={getCountryCodeList(t)}
                    onOptionChange={this.handleCountryCodeChange}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.phone")}
                    <RedAsterisk>*</RedAsterisk>
                  </ContentSubtitle>
                  <Input
                    onChange={this.handleInputChange}
                    id="phone"
                    type="tel"
                    value={phone}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.email")}
                    <RedAsterisk>*</RedAsterisk>
                  </ContentSubtitle>
                  <Input
                    onChange={this.handleInputChange}
                    id="email"
                    type="email"
                    value={email}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.createdAt")}
                  </ContentSubtitle>
                  <Input disabled={true} value={createdAt} />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.title")}
                    <RedAsterisk>*</RedAsterisk>
                  </ContentSubtitle>
                  <Input
                    onChange={this.handleInputChange}
                    id="title"
                    type="text"
                    value={title}
                  />
                </ContentContainer>
              </GridColumn>

              <GridColumn>
                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.consultationUrl")}
                  </ContentSubtitle>
                  <Input
                    onChange={this.handleInputChange}
                    id="consultationUrl"
                    type="url"
                    value={consultationUrl}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.cnConsultationUrl")}
                  </ContentSubtitle>
                  <Input
                    onChange={this.handleInputChange}
                    id="cnConsultationUrl"
                    type="url"
                    value={cnConsultationUrl}
                  />
                </ContentContainer>

                <ContentContainer>
                  <ContentSubtitle>
                    {t("admin.coach.profilePicture")}
                  </ContentSubtitle>
                  <ImageUploader
                    beforeUpload={this.beforeUpload}
                    handleUploadImageForPreview={
                      this.handleUploadImageForPreview
                    }
                    image={{
                      avatarPreview: avatarPreview,
                      avatarFilename: avatarFilename,
                      isUploaded: isUploaded,
                    }}
                    s3FolderRoute={COACH_PROFILE_PICTURE_FOLDER_ON_S3_ROUTE}
                  />
                </ContentContainer>
                <ContentContainer>
                  <ContentSubtitle>{t("admin.coach.disabled")}</ContentSubtitle>
                  <label>
                    <input
                      type="checkbox"
                      checked={disabled}
                      onChange={(e) =>
                        this.setState({ disabled: e.target.checked })
                      }
                    />
                    {t("admin.coach.disableAccount")}
                  </label>
                </ContentContainer>
                <ContentContainer>
                  <ResetPasswordButton>
                    <span onClick={this.showResetPasswordModal}>
                      {t("admin.therapist.resetPassword")}
                    </span>
                  </ResetPasswordButton>
                </ContentContainer>
                <ResetPasswordModal
                  visible={isResetPasswordModalVisible}
                  onClose={this.closeResetPasswordModal}
                  uuid={coachUUID}
                />
              </GridColumn>
            </ContainerWithGrid>
            {/* Coach Bio Section */}
            <div style={{ width: "90%", marginLeft: "5%" }}>
              <Title>{t("admin.coach.bio")}</Title>
              <UploadContainer>
                <ContentSubtitle
                  style={{ fontSize: "16px", fontStyle: "italic" }}
                >
                  {t("admin.coach.bioDescriptionMessage")}
                </ContentSubtitle>
                <TherapistBioTextbox
                  currParentComponent="edit"
                  bio={bio}
                  handleBio={this.handleBio}
                  handleDeleteBio={this.handleDeleteBio}
                />
                <div style={{ display: "flex" }}>
                  {dataSourceEN.length > 0 && (
                    <Table
                      pagination={false}
                      columns={columnEN}
                      dataSource={dataSourceEN}
                    ></Table>
                  )}
                  {dataSourceZH_CN.length > 0 && (
                    <Table
                      pagination={false}
                      columns={columnZH_CN}
                      dataSource={dataSourceZH_CN}
                    ></Table>
                  )}
                  {dataSourceZH_TW.length > 0 && (
                    <Table
                      pagination={false}
                      columns={columnZH_TW}
                      dataSource={dataSourceZH_TW}
                    ></Table>
                  )}
                </div>
              </UploadContainer>
            </div>

            {/* Coach Assignments Section */}
            <div style={{ width: "90%", marginLeft: "5%", marginTop: "24px" }}>
              <Title>Coach Assignments</Title>
              <CoachAssignmentView coachId={this.props.match.params.id} />
            </div>

            <ContentContainer>
              <CancelButton onClick={this.onCancelClick}>
                {t("admin.common.cancel")}
              </CancelButton>
              <SaveButton onClick={() => this.onSaveClick()}>
                {t("admin.common.save")}
              </SaveButton>
            </ContentContainer>
          </div>
        )}
      </div>
    );
  };
}

export default withTranslation()(EditCoach);
